import { Button, Modal } from "react-bootstrap";
import { BadgeStatus } from "../../badges/statusBadge";
import DateFormat from "../../format/DateFormat";
import DecimalNumberCents from "../../format/DecimalNumberCents";

type ViewContractModalProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
  item?: any;
};

// TODO: quando excluir algo e não tiver mais nenhum item na página -> resetar paginação

const ViewContractModal: React.FC<ViewContractModalProps> = ({
  showModal,
  item,
  setShowModal,
  handleClose,
}) => {
  return (
    <Modal show={showModal} className="" onHide={handleClose} centered={true}>
      <Modal.Header className="d-flex align-items-center" closeButton>
        <Modal.Title>Detalhes do contrato</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {item ? (
          <div className="row">
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Descrição:</label>
              <span>{item?.description}</span>
            </div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Nome do Plano:</label>
              <span>{item?.plan_name}</span>
            </div>
            <div className="separator my-5"></div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Duração do plano:</label>
              <span>{item?.plan_duration}</span>
            </div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Valor do plano:</label>
              <DecimalNumberCents
                value={item?.plan_amount}
                prefix="R$ "
              ></DecimalNumberCents>
            </div>
            <div className="separator my-5"></div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Data de início:</label>
              <span>
                <div className="">
                  <DateFormat date={item?.start_date}></DateFormat>
                </div>
              </span>
            </div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Data final:</label>
              <span>
                <div className="">
                  <DateFormat date={item?.final_date}></DateFormat>
                </div>
              </span>
            </div>
            <div className="separator my-5"></div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">
                Dia de vencimento das cobranças:
              </label>
              <span>
                <div>
                  <span>{item?.charge_payment_day}</span>
                </div>
              </span>
            </div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Prazo indeterminado:</label>
              <div>
                <BadgeStatus
                  description={item?.indefinite_term ? "yes" : "no"}
                />
              </div>
            </div>
            <div className="separator my-5"></div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Pagamento à vista:</label>
              <div>
                <BadgeStatus
                  description={item?.payment_upfront ? "yes" : "no"}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex flex-column">
              <label className="fw-bold">Status:</label>
              <div>
                <BadgeStatus description={item?.status?.description} />
              </div>
            </div>
          </div>
        ) : (
          showModal && (
            <div className="row d-flex justify-content-center align-items-center">
              <span
                style={{ width: "50px", height: "50px" }}
                className="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </div>
          )
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewContractModal;
